import isPlainObject from 'lodash/isPlainObject';

export function validateData(obj, untilTime) {
  if (isPlainObject(obj) || Array.isArray(obj)) {
    if ('invalidated' in obj) {
      const t = Number.parseInt(obj.invalidated, 10);
      if (t <= untilTime || !untilTime) {
        delete obj.invalidated;
      }
    }

    for (const n in obj) {
      validateData(obj[n], untilTime);
    }
  }
}

export function isDataInvalid(obj) {
  if (isPlainObject(obj) || Array.isArray(obj)) {
    if ('invalidated' in obj) {
      return true;
    } else {
      for (const n in obj) {
        if (isDataInvalid(obj[n])) {
          return true;
        }
      }
    }
  }

  return false;
}

export function dataIsEmpty(data, callback) {
  if (isPlainObject(data) || Array.isArray(data)) {
    for (const n in data) {
      if (!dataIsEmpty(data[n], callback)) {
        return false;
      }
    }
    return true;
  } else {
    return callback ? callback(data) : !data;
  }
}
